export {default} from './NotFound';


// WEBPACK FOOTER //
// ./src/containers/NotFound/index.js